(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["cart-template"]) return;
  try {
    

jQuery(document).ready(function ($) {

  // Sticky summary
  let header = $('#shopify-section-header')
  let top = 20

  if ($(header).css('position') == 'sticky') {
    top += header.outerHeight()
  }

  $('.sticky-cart-summary').css({
    'position': 'sticky',
    'top': top,
    'z-index': 1019
  })

})


  } catch(e) { console.error(e); }
})();

})();
